import { Grid, styled, Typography, useTheme } from '@mui/material';
import { images } from '../../url/SvgLinks';
import { getDynamicBorder, getStringProduct } from '../../utils/utilityFunctions';

const Wrapper = styled('div')(({ border, padding, justifyContent, theme, height }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  justifyContent: justifyContent || 'center',
  border: border || `2px solid ${theme.palette.border.containerborder}`,
  padding: padding || '7px 10px',
  height: height || '100%',
  [theme.breakpoints.up('xll')]: {
    height: getStringProduct(1.25, height) || '100%',
    border: getDynamicBorder(1.25, border || `2px solid ${theme.palette.border.containerborder}`),
    borderRadius: getStringProduct(1.25, '8px'),
    padding: getStringProduct(1.25, padding || '7px 10px')
  },
  [theme.breakpoints.up('xlll')]: {
    height: getStringProduct(1.66, height) || '100%',
    border: getDynamicBorder(1.66, border || `2px solid ${theme.palette.border.containerborder}`),
    borderRadius: getStringProduct(1.66, '8px'),
    padding: getStringProduct(1.66, padding || '7px 10px')
  },
  [theme.breakpoints.up('xl4')]: {
    height: getStringProduct(2.46, height) || '100%',
    border: getDynamicBorder(2.46, border || `2px solid ${theme.palette.border.containerborder}`),
    borderRadius: getStringProduct(2.46, '8px'),
    padding: getStringProduct(2.46, padding || '7px 10px')
  }
}));

const ImagIcon = styled('img')(({ theme }) => ({
  width: '32px',
  height: '24px',
  marginRight: '8px',
  [theme.breakpoints.up('xll')]: {
    width: getStringProduct(1.25, '32px'),
    height: getStringProduct(1.25, '24px'),
    marginRight: getStringProduct(1.25, '8px')
  },
  [theme.breakpoints.up('xlll')]: {
    width: getStringProduct(1.66, '32px'),
    height: getStringProduct(1.66, '24px'),
    marginRight: getStringProduct(1.66, '8px')
  },
  [theme.breakpoints.up('xl4')]: {
    width: getStringProduct(2.46, '32px'),
    height: getStringProduct(2.46, '24px'),
    marginRight: getStringProduct(2.46, '8px')
  }
}));

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',

  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '12px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '12px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '12px')
  }
}));

const youtubeIcon = images.youtubeIcon;

const YoutubeVideo = ({ border, padding, justifyContent,  text = 'Watch Intro', onClick, height }) => {
  const theme = useTheme();
  return (
    <Wrapper
      height={height}
      border={border}
      padding={padding}
      justifyContent={justifyContent}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      <ImagIcon src={youtubeIcon} alt="img" />
      <Grid item>
        <StyledText>{text}</StyledText>
      </Grid>
    </Wrapper>
  );
};

export default YoutubeVideo;
